import vent from 'elements/vent';
import dialogs from 'elements/dialogs';
import flash from 'elements/flash';
import utils from 'elements/pcs-utils';
import ui from 'elements/pcs-ui';
import tracking from 'elements/tracking';
import * as components0 from '/Users/cedricdevassine/Works/akitchen/axaa-mcea/www2/wp-content/themes/hello-elementor-child/components/pcs/pcs-auth/pcs-page-register.js'; import * as components1 from '/Users/cedricdevassine/Works/akitchen/axaa-mcea/www2/wp-content/themes/hello-elementor-child/components/pcs/pcs-common/pcs-menu.js'; import * as components2 from '/Users/cedricdevassine/Works/akitchen/axaa-mcea/www2/wp-content/themes/hello-elementor-child/components/pcs/pcs-page-form/pcs-form-note/pcs-form-note.js'; import * as components3 from '/Users/cedricdevassine/Works/akitchen/axaa-mcea/www2/wp-content/themes/hello-elementor-child/components/pcs/pcs-page-form/pcs-form-reminder/pcs-form-reminder.js'; import * as components4 from '/Users/cedricdevassine/Works/akitchen/axaa-mcea/www2/wp-content/themes/hello-elementor-child/components/pcs/pcs-page-form/pcs-form-timeline/pcs-form-timeline.js'; import * as components5 from '/Users/cedricdevassine/Works/akitchen/axaa-mcea/www2/wp-content/themes/hello-elementor-child/components/pcs/pcs-page-form/pcs-form-values/pcs-form-values.js'; import * as components6 from '/Users/cedricdevassine/Works/akitchen/axaa-mcea/www2/wp-content/themes/hello-elementor-child/components/pcs/pcs-page-form/pcs-page-form.js';var components = {
                        "pcs-page-register":components0
                      ,
                        "pcs-menu":components1
                      ,
                        "pcs-form-note":components2
                      ,
                        "pcs-form-reminder":components3
                      ,
                        "pcs-form-timeline":components4
                      ,
                        "pcs-form-values":components5
                      ,
                        "pcs-page-form":components6
                      };
document.documentElement.classList.add('js');
window.addEventListener('DOMContentLoaded', function (event) {
  // init device context
  window.device = {
    muted: false,
    animation: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    touch: !window.matchMedia('(pointer: fine)').matches,
    ios: navigator && navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)
  };
  vent.publish('APP:READY');
});